import axios from "axios";

let config = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem("__myTeken")}`,
  },
};
export const modif_password = async (d) => {
  try {
    const { data } = await axios.post("utilisateur/acteur/update-credential", d, config);
    return data;
  } catch (error) {
    return error;
  }
};